import { EntityTypes } from "@vzbl/integrations";
import { useApplicationContext } from "src/hooks/useApplication";
import { IntegrationIcon } from "src/components/IntegrationIcon";
import { useEntityContext } from "../useEntityContext";
import { EntityScreen } from "./components/layout/Screen";
import { HeaderPanel } from "./components/layout/HeaderPanel";
import { ActionCard } from "./components/ActionCard";
import { SummaryTag } from "./components/Tags";
import { SummaryPanel } from "./components/layout/SummaryPanel";
import { InsightsPanel } from "./components/layout/InsightsPanel";
import { toHeaderAttributes } from "./components/HeaderAttributes";
import { EntityTabs } from "./components/EntityTabs";
import { generateWorkTabs } from "../components/worktabs";
import { TabbedWork } from "../components/TabbedWork";
import { SentencesList } from "./components/SentencesList";
import { TimeMachine, TimeMachineComponent } from "../TimeMachine";
import { Insights } from "../Insights";

export const CicdPipelineEntity = () => {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  const properties = context.dataRef.current.entity.properties;
  const entityType = context.dataRef.current.entity.labels[0];

  return (
    <EntityScreen
      headerPanel={
        <HeaderPanel
          label={properties.name}
          entity={context.dataRef.current.entity}
          attributes={toHeaderAttributes({
            orgId,
            context,
            entityType,
            attributes: [
              { name: "branch", text: properties.branch },
              { name: "repository", text: properties.repository },
            ],
          })}
          icon={
            <IntegrationIcon source={properties.integration} size="large" />
          }
        />
      }
      summaryPanel={
        <SummaryPanel
          title={properties.name}
          contentComponent={
            <ul>
              <li>
                State <strong>{properties.state}</strong>
              </li>
              <li>
                Created{" "}
                <strong>
                  {new Date(properties.createdAt).toLocaleString()}
                </strong>
              </li>
            </ul>
          }
        />
      }
      insightsPanel={
        <InsightsPanel
          cards={[
            properties.vzblValueStatement && (
              <ActionCard
                key="value-statement"
                badge={<SummaryTag />}
                label="Value Statement"
                value={
                  <SentencesList showNa data={properties.vzblValueStatement} />
                }
              />
            ),
          ].filter(Boolean)}
        />
      }
    >
      <EntityTabs
        propertiesSkipList={[
          "branch",
          "repository",
          "name",
          "state",
          "createdAt",
          "vzblValueStatement",
        ]}
        entity={context.dataRef.current.entity}
        tabs={[
          {
            key: "overview",
            id: "overview",
            label: "Overview",
            children: <Insights entity={context.dataRef.current.entity} />,
          },
          {
            key: "History",
            id: "History",
            label: "History",
            children: (
              <TimeMachine>
                <TimeMachineComponent />
              </TimeMachine>
            ),
          },
          {
            id: "work",
            key: "work",
            label: "Work",
            children: (
              <TabbedWork
                items={generateWorkTabs(properties.orgId, properties.uuid, [
                  { entityTypes: EntityTypes.Commit },
                  {
                    entityTypes: EntityTypes.PullRequest,
                    label: "Pull Requests",
                  },
                  { entityTypes: EntityTypes.Branch, label: "Branches" },
                  {
                    entityTypes: EntityTypes.Repository,
                    label: "Repositories",
                  },
                ])}
              />
            ),
          },
        ]}
      />
    </EntityScreen>
  );
};
